<template>
  <b-modal
    hide-footer
    title="คุณต้องการส่งไฟล์"
    v-model="showModal"
    size="sm"
    centered
  >
    <div class="" v-for="(file, index) in files" :key="index">
      <font-awesome-icon icon="file-upload" class="icon-type" />
      {{ file.name }}
    </div>
    <div class="row w-100 m-0 mt-3">
      <div class="col-12 col-sm-6 p-1">
        <b-button
          @click="confirm"
          variant="main-primary"
          class="w-100 confirm-btn"
        >
          ยืนยัน
        </b-button>
      </div>
      <div class="col-12 col-sm-6 p-1">
        <b-button @click="hide" variant="outline-primary" class="w-100">
          ยกเลิก
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    files: {
      type: Array,
      default: () => [],
      required: false
    }
  },
  watch: {
    showModal(val) {
      if (!val) {
        this.$emit("handleHideSendFile");
      }
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    confirm() {
      this.$emit("handleConfirmSendFile", this.files);
      this.hide();
    }
  }
};
</script>

<style lang="scss" scoped>
.confirm-btn {
  min-width: 100px !important;
}
</style>
